<template>
  <nav
    v-if="items.length > 1"
    aria-label="breadcrumb"
    class="base-breadcrumb"
  >
    <ol
      class="breadcrumb-list"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <li
        v-for="(item, i) in items"
        :key="i"
        class="breadcrumb-item"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <router-link
          v-if="item.to"
          :to="item.to"
          itemprop="item"
          class="breadcrumb-link"
        >
          <span itemprop="name">{{ item.text }}</span>
        </router-link>
        <span
          v-else
          class="breadcrumb-current"
          itemprop="name"
        >
          {{ item.text }}
        </span>
        <meta
          itemprop="position"
          :content="String(i + 1)"
        >
        <span
          v-if="i < items.length - 1"
          class="breadcrumb-separator"
        >
          /
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
  export default {
    name: 'BaseBreadcrumb',

    props: {
      // 面包屑项数组，每项: { text: '显示文本', to: '路由路径(可选)' }
      items: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style scoped>
  .base-breadcrumb {
    padding: 12px 0;
  }

  .breadcrumb-list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0;
    margin: 0;
    font-size: 14px;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
  }

  .breadcrumb-link {
    color: #EB5C20;
    text-decoration: none;
  }

  .breadcrumb-link:hover {
    text-decoration: underline;
  }

  .breadcrumb-current {
    color: #666;
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: #999;
  }
</style>
